import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ptBR from './locales/pt-BR.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'pt-BR': { translation: ptBR },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt-BR'],
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'openmat_lang',
      caches: ['localStorage'],
      // Normalize detected codes to our supported ones. Mapping en-US/en-GB/…
      // → en matters: i18next's matcher does an exact-match pass over the
      // WHOLE browser language list before trying language-only codes, so
      // ['en-US', 'pt-BR'] used to resolve to pt-BR — English-first devices
      // with Portuguese anywhere in their list got the PT site.
      convertDetectedLanguage: (lng) => {
        const l = (lng || '').toLowerCase();
        if (l.startsWith('pt')) return 'pt-BR';
        if (l.startsWith('en')) return 'en';
        return lng;
      },
    },
  });

export default i18n;
